import styled from 'styled-components';

export const ModalWrapper = styled.div`
  font-family: var(--font-family-alt);
  font-size: 0.9rem;
  .question-text {
    margin-bottom: 25px;
    font-weight: 400;
    font-size: 1rem;
    color: #444;
    line-height: 1.5;
  }
  .rs-btn-primary {
    font-weight: 500;
  }
  .rs-modal-title,
  header {
    font-weight: 500;
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    i {
      font-size: 28px;
      margin-right: 10px;
      color: rgba(var(--ion-color-primary-rgb), 0.6);
    }
  }
  .uppy-Dashboard {
    height: 300px;
    &.uppy-Dashboard,
    &.uppy-size--md,
    &.uppy-size--lg {
      .uppy-StatusBar,
      .uppy-StatusBar.is-waiting {
        &:not([aria-hidden='true']).is-waiting {
          height: 85px;
        }

        .uppy-StatusBar-actionBtn--upload {
          padding: 18px 22px;
          font-weight: 500;
          font-family: var(--font-family-alt);
          width: 100%;
          font-size: 16px;
        }
      }

      .uppy-Audio-buttonContainer,
      .uppy-Webcam-buttonContainer {
        width: 100%;
        flex: auto;
        margin-left: 0;
        text-align: center;
      }
      .uppy-Webcam-button,
      .uppy-Audio-button {
        width: 125px;
        height: 45px;
        border-radius: 10px;
        &:hover {
          background: var(--chakra-colors-red-500);
        }
        svg {
          width: 20px;
          height: 20px;
        }
        &.uppy-Webcam-button--submit,
        &.uppy-Audio-button--submit {
          background: var(--chakra-colors-green-500);
          &:hover {
            background: var(--chakra-colors-green-600);
          }
        }
      }

      .uppy-DashboardTab-name {
        font-size: 13px;
      }
      .uppy-DashboardTab {
        margin: 0 10px 10px;
        svg {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
  .video-response,
  .image-response,
  .audio-response {
    &.image-response {
      header i {
        color: rgb(var(--type3-color));
      }
    }
    &.text-response {
      header i {
        color: rgb(var(--type4-color));
      }
    }
    &.audio-response {
      header i {
        color: rgb(var(--type1-color));
      }
    }
    &.video-response {
      header i {
        color: rgb(var(--type2-color));
      }
      .uppy-DragDrop--isDragDropSupported {
        border-color: #32b0d8;
        border-width: 3px;
      }
    }
  }
`;
